<template>
  <div class="products-individuals-wrapper">
    <IndividualsHeader :el="'au'" />
    <div class="text-group">
      <h3 class="text-au">{{ $t('products-au-1') }}</h3>
      <p>{{ $t('products-au-2') }}</p>
      <p>{{ $t('products-au-3') }}</p>
    </div>
    <Gallery :gallery="gallery" />
    <div class="content-row">
      <Dropdown
        :id="'auDropdownOne'"
        :color="color"
        :title="$t('products-au-dd1-1')"
        :content="dropdownOne"
        :open="true"
      />
    </div>
    <div class="content-row" id="alloysElement">
      <Dropdown
        :id="'auDropdownTwo'"
        :color="color"
        :title="$t('products-au-dd2-1')"
        :content="dropdownTwo"
        :open="true"
      />
    </div>
    <div class="content-row">
      <Files :color="color" :files="files" />
    </div>
    <InterestingFacts :title="$t('products-au-if-title')" :facts="facts" :color="color" />
  </div>
</template>

<script>
import IndividualsHeader from "./shared/IndividualsHeader";
import InterestingFacts from "./shared/InterestingFacts";
import Dropdown from "./shared/Dropdown";
import Gallery from "./shared/Gallery";
import Files from "./shared/Files";

export default {
  components: {
    IndividualsHeader,
    InterestingFacts,
    Dropdown,
    Gallery,
    Files
  },
  props: ["color"],
  data() {
    return {
      gallery: [
        {
          type: "image",
          url: require("../../../assets/img/products/au/au_gallery_1.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/au/au_gallery_2.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/au/au_gallery_3.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/au/au_gallery_4.jpg")
        },
        {
          type: "image",
          url: require("../../../assets/img/products/au/au_gallery_5.jpg")
        }
      ],
      files: {
        bg: ["Брошура КЦМ Злато.pdf"],
        en: ["Brochure KCM Gold.pdf"]
      }
    };
  },
  computed: {
    dropdownOne() {
      return {
        table: [
          [this.$t("brand"), "Au 99.99 min.", "Au 99.98 min.", "Au 99.95 min."],
          [this.$t("elements"), "%", "%", "%"],
          [{ el: "Cu" }, "0.005 max.", "0.005 max.", "0.02 max."],
          [{ el: "Fe" }, "0.002 max.", "0.003 max.", "0.005 max."],
          [{ el: "Pb" }, "0.002 max.", "0.003 max.", "0.0015 max."],
          [{ el: "Bi" }, "0.002 max.", "0.002 max.", "0.0015 max."],
          [{ el: "Pd" }, "0.005 max.", "0.007 max.", "0.010 max."],
          [{ el: "Ag" }, "0.009 max.", "0.014 max.", "-"],
          [{ el: "Sb" }, "0.001 max.", "0.002 max.", "-"],
          [this.$t("products-dd-11"), "0.01 max.", "0.02 max.", "0.05 max."]
        ],
        columns: {
          titles: [this.$t("products-au-dd1-2")],
          left: [
            {
              img: require("../../../assets/img/products/au/dd1.jpg")
            }
          ],
          right: [
            {
              spec: {
                title: this.$t("products-dd-12"),
                mass: this.$t("products-au-dd1-3"),
                left: this.$t("products-dd-13"),
                right: this.$t("products-dd-14"),
                l0: this.$t("products-au-dd1-4"),
                w0: this.$t("products-au-dd1-5"),
                l: this.$t("products-au-dd1-6"),
                w: this.$t("products-au-dd1-7"),
                h: this.$t("products-au-dd1-8")
              }
            },
            {
              texts: [this.$t("products-au-dd1-9")]
            },
            {
              title: this.$t("products-au-dd1-10"),
              texts: [
                this.$t("products-au-dd1-11"),
                this.$t("products-au-dd1-12")
              ]
            }
          ]
        }
      };
    },
    dropdownTwo() {
      return {
        table: [
          [this.$t("products-dd-15"), this.$t("products-dd-16")],
          [this.$t("products-au-dd2-2"), this.$t("products-au-dd2-3")],
          [this.$t("products-au-dd2-4"), this.$t("products-au-dd2-5")],
          [this.$t("products-au-dd2-6"), this.$t("products-au-dd2-7")]
        ],
        columns: {
          left: [
            {
              img: require("../../../assets/img/products/au/dd2.jpg")
            }
          ],
          right: [
            {
              title: this.$t("products-au-dd2-8"),
              texts: [
                this.$t("products-au-dd2-9"),
                this.$t("products-au-dd2-10"),
                this.$t("products-au-dd2-11"),
                this.$t("products-au-dd2-12")
              ]
            }
          ]
        }
      };
    },
    facts() {
      return [
        {
          img: require("../../../assets/img/products/au/if_1.png"),
          text: this.$t("products-au-if-1")
        },
        {
          img: require("../../../assets/img/products/au/if_2.png"),
          text: this.$t("products-au-if-2")
        },
        {
          img: require("../../../assets/img/products/au/if_3.png"),
          text: this.$t("products-au-if-3")
        },
        {
          img: require("../../../assets/img/products/au/if_4.png"),
          text: this.$t("products-au-if-4")
        },
        {
          img: require("../../../assets/img/products/au/if_5.png"),
          text: this.$t("products-au-if-5")
        },
        {
          img: require("../../../assets/img/products/au/if_6.png"),
          text: this.$t("products-au-if-6")
        },
        {
          img: require("../../../assets/img/products/au/if_7.png"),
          text: this.$t("products-au-if-7")
        },
        {
          img: require("../../../assets/img/products/au/if_8.png"),
          text: this.$t("products-au-if-8")
        },
        {
          img: require("../../../assets/img/products/au/if_9.png"),
          text: this.$t("products-au-if-9")
        },
        {
          img: require("../../../assets/img/products/au/if_10.png"),
          text: this.$t("products-au-if-10")
        },
        {
          img: require("../../../assets/img/products/au/if_11.png"),
          text: this.$t("products-au-if-11")
        },
        {
          img: require("../../../assets/img/products/au/if_12.png"),
          text: this.$t("products-au-if-12")
        },
        {
          img: require("../../../assets/img/products/au/if_13.png"),
          text: this.$t("products-au-if-13")
        },
        {
          img: require("../../../assets/img/products/au/if_14.png"),
          text: this.$t("products-au-if-14")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.products-individuals-wrapper {
  padding-bottom: 50px;
  .text-group {
    margin: 0 auto;
    padding-top: 40px;
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
  .content-row {
    padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
    padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  }
}
@media screen and (max-width: 1600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge1440 +
        ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1280px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
    .content-row {
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
    .content-row {
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 600px) {
  .products-individuals-wrapper {
    .text-group {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
    .content-row {
      padding-right: $sidesPadding600;
      padding-left: $sidesPadding600;
    }
  }
}
</style>

